
//valores del empleado
export const LOADING_EMPLOYEE_VALUE = "LOADING_EMPLOYEE_VALUE";
export const SAVE_LOADING_EMPLOYEE_VALUE = "SAVE_LOADING_EMPLOYEE_VALUE";
export const GET_EMPLOYEE_VALUE = "GET_EMPLOYEE_VALUE";
export const FORM_FAIL_EMPLOYEE_VALUE = "FORM_FAIL_EMPLOYEE_VALUE";
export const EMPLOYEE_VALUE_FAIL = "EMPLOYEE_VALUE_FAIL";
export const LOADING_EMPLOYEE_VALUE_BY_ID = "LOADING_EMPLOYEE_VALUE_BY_ID";
export const GET_EMPLOYEE_VALUE_BY_ID = "GET_EMPLOYEE_VALUE_BY_ID";

//valores del jefe
export const LOADING_BOSS_VALUE = "LOADING_BOSS_VALUE";
export const SAVE_LOADING_BOSS_VALUE = "SAVE_LOADING_BOSS_VALUE";
export const GET_BOSS_VALUE = "GET_BOSS_VALUE";
export const FORM_FAIL_BOSS_VALUE = "FORM_FAIL_BOSS_VALUE";
export const BOSS_VALUE_FAIL = "BOSS_VALUE_FAIL";
export const LOADING_BOSS_VALUE_BY_ID = "LOADING_BOSS_VALUE_BY_ID";
export const GET_BOSS_VALUE_BY_ID = "GET_BOSS_VALUE_BY_ID";

